module.exports = __webpack_public_path__ + "static/media/closed.d008bd78.svg";